let firstArrImg = [];
let lastArrImg = [];
let noPhoto = 1;

function changeImage(img) {
    const photos = document.querySelectorAll('.photo');
    photos.forEach((photo) => {
        photo.classList.remove('active');
    });
    const span = document.querySelector(`.photo-${noPhoto}`);
    span.classList.add('active');
    const tagImg = document.querySelector(`.photo-${noPhoto} img`);
    tagImg.src = img;
    lastArrImg.push(firstArrImg[0]);
    firstArrImg.shift();
}
function selectImage() {
    if (firstArrImg.length === 0) {
        firstArrImg = lastArrImg;
        lastArrImg = [];
    }
    const img = firstArrImg[0];
    changeImage(img);
    if (noPhoto === 3) {
        noPhoto = 1;
    } else {
        noPhoto += 1;
    }
    setTimeout(selectImage, 6000);
}

if (document.querySelector('.carrieres-header-content')) {
    const getUrls = document.querySelector('.carrieres-header-content').getAttribute('data-changing-photos');
    const parseUrls = JSON.parse(getUrls);
    firstArrImg = parseUrls;

    window.addEventListener('load', () => {
        for (let i = 0; i < 3; i += 1) {
            const image = document.querySelector(`.photo-${i + 1} img`);
            const srcImg = firstArrImg[0];
            image.src = srcImg;
            lastArrImg.push(firstArrImg[0]);
            firstArrImg.shift();
        }
        setTimeout(selectImage, 6000);
    }, false);
}
